module.exports = __webpack_public_path__ + "public/img/img-mobile-yec-1.6436de55.png";